import { toQuery } from '@spa/components/pages/order/scope-transpiler'
import { Order } from '@spa/store/modules/orderHistory/types'

type OrderMinimumDep = Pick<Order,
  'bundleDiscountedPrice' |
  'couponDiscountedPrice' |
  'estimatedPoints' |
  'campaignId' |
  'couponId' |
  'cartScope' |
  'pointCalculationJson' |
  'referral' |
  'orderSource'
>

/**
 * 再注文（再決済）時に元注文から引き継ぐべきauxのデータ.
 *
 * 本来はドメインモデル的な層で定義するのが理想だが、現状の再注文のペイロードが手続き的に作成されているので、
 * ひとまずその手続きの一部を関数に切り出すだけにとどめている
 *
 * 通常の注文と再注文で作成される注文レコードのフォーマットの差をなくすため、
 * 元注文の値がfalsyな値（0, '', etc）であっても引き継ぐこととしている。
 * 一方で、空文字はそもそも元注文時に入れないようにしたほうが良いかもしれない。
 */
export const createTransferAuxDataOnReorder = (order: OrderMinimumDep): Record<string, string | number> => {
  return {
    ...(order.bundleDiscountedPrice !== undefined && Number.isInteger(order.bundleDiscountedPrice))
      && { aux_long_2: order.bundleDiscountedPrice },
    ...(order.couponDiscountedPrice !== undefined && Number.isInteger(order.couponDiscountedPrice))
      && { aux_long_3: order.couponDiscountedPrice },
    ...(order.estimatedPoints !== undefined && Number.isInteger(order.estimatedPoints))
      && { aux_long_4: order.estimatedPoints },
    ...order.campaignId !== undefined && { aux_string_4: order.campaignId },
    ...order.couponId !== undefined && { aux_string_5: order.couponId },
    ...order.cartScope && { aux_string_9: toQuery(order.cartScope) },
    ...order.pointCalculationJson !== undefined && { aux_text_3: order.pointCalculationJson },
    // Engine側ではあくまで文字列として保持されているため、stringifyを噛ませている
    ...order.referral && { aux_string_13: JSON.stringify(order.referral) },
    ...order.orderSource.fold(
      () => ({}),
      value => ({ aux_string_14: value })
    ),
  }
}
